import { useQuery } from '@apollo/client';
import { FileAttachmentsWidget } from '@procureai/ui-modules-mui';
import { isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';

import { FileAttachmentStatus } from '../../FileAttachmentsWidget/FileAttachmentsWidget.types';
import {
  classificationOptions,
  getAttachmentFragments,
  useFileAttachmentsUpdateMutation,
} from '../../FileAttachmentsWidget/FileAttachmentsWidget.util';
import { useSourcingCase } from '../../Module.hooks';
import { TsrctAttachmentParentVariant, TsrctUploadedByVariant } from '@/generated/gql/graphql';
import { isSourcingCaseEditable } from '@/legacy/common/guards/sourcingCase.guards';
import { I18nNamespace } from '@/legacy/common/types/I18nNamespace';

import { SOURCING_CASE_SUPPLIER_FILE_ATTACHMENTS_QUERY } from './SourcingCaseSupplierFileAttachmentsWidget.gql';

export const SourcingCaseSupplierFileAttachmentsWidget = () => {
  const { id } = useSourcingCase();
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'SourcingCaseSupplierFileAttachmentsWidget' });
  const sourcingCaseParent = {
    id,
    variant: TsrctAttachmentParentVariant.SOURCING_CASE,
  };

  const variables = {
    parents: [sourcingCaseParent],
    filter: {
      uploadedByVariants: [TsrctUploadedByVariant.SUPPLIER_USER],
    },
    sourcingCaseId: id,
  };

  const { data, loading } = useQuery(SOURCING_CASE_SUPPLIER_FILE_ATTACHMENTS_QUERY, {
    variables,
  });

  const { save, saving } = useFileAttachmentsUpdateMutation({
    refetchQueries: [{ query: SOURCING_CASE_SUPPLIER_FILE_ATTACHMENTS_QUERY, variables }],
    parent: sourcingCaseParent,
  });

  const attachments = getAttachmentFragments(data?.tesseract.attachments);

  return (
    <FileAttachmentsWidget
      editFeatures={[]}
      title={t('title')}
      emptyStateTitle={t('empty')}
      uploadButtonLabel={t('upload.buttonLabel')}
      attachments={attachments}
      loading={loading}
      onSave={save}
      saving={saving}
      isEditable={isSourcingCaseEditable(data?.tesseract.sourcingCase) && !loading && !isEmpty(attachments)}
      getItemStatus={(attachment) =>
        attachment.visibilities.some((v) => v.id === id) ? FileAttachmentStatus.VISIBLE : FileAttachmentStatus.HIDDEN
      }
      isItemDeletable={(attachment) => attachment.parent.id === id}
      classificationOptions={classificationOptions}
      getItemClassification={(attachment) => attachment.classification}
    />
  );
};
